import { FC } from "react";
import styled from "@emotion/styled";
import { SettingsSubsectionWrapper } from "@/pages/settings/components/setting-subsection-wrapper";
import { SettingsSectionWrapper } from "@/pages/settings/components/settings-section-wrapper";
import { observer } from "mobx-react-lite";
import { MDSLink, MDSText, MDSTextVariant, MDSTextWeight, MDSToggle } from "@/mds";
import { APP_CONFIG } from "@/domains/global/config";
import { windowModule } from "@/modules/window";
import { useAppStore } from "@/store";
import { useSettingsNotificationPreferencesPageBehavior } from "@/pages/settings/settings-notification-preferences-page.hooks";

export const SettingsNotificationPreferencesPage: FC = observer(() => {
  const { store } = useAppStore();
  const isDesktop = store.interface.isDesktop;
  const isWindows = store.interface.isWindows;
  const isIntelMacDesktop = store.electron.isIntelMacDesktop;

  const { isSaving, meetingNotificationEnabled, toggleMeetingNotificationPreference } =
    useSettingsNotificationPreferencesPageBehavior();

  return (
    <SettingsSectionWrapper>
      <SettingsSubsectionWrapper title="Notification preferences">
        <Selector>
          <MDSText variant={MDSTextVariant.ParagraphS}>
            Suggest starting a voice note anytime a meeting is detected
          </MDSText>
          <MDSToggle
            disabled={!isDesktop || isIntelMacDesktop || isSaving}
            checked={meetingNotificationEnabled}
            onChange={() => {
              void toggleMeetingNotificationPreference();
            }}
          />
        </Selector>
        {!isDesktop && (
          <MDSText variant={MDSTextVariant.ParagraphS} weight={MDSTextWeight.SemiBold}>
            Use this feature in the{" "}
            <MDSLink
              onPress={() => {
                windowModule.openInNewTab({
                  url: new URL(isWindows ? APP_CONFIG.URLS.WINDOWS_APP : APP_CONFIG.URLS.MAC_APP),
                });
              }}
            >
              {isWindows ? "Windows" : "Mac"} app
            </MDSLink>
            .
          </MDSText>
        )}
        {isIntelMacDesktop && (
          <MDSText variant={MDSTextVariant.ParagraphS} weight={MDSTextWeight.SemiBold}>
            This feature is not currently supported on your device.{" "}
            <MDSLink
              onPress={() => {
                windowModule.openInNewTab({
                  url: new URL(APP_CONFIG.URLS.FAQ_MEETING_NOTIFICATIONS_NOT_SUPPORTED),
                });
              }}
            >
              Learn more
            </MDSLink>
          </MDSText>
        )}
      </SettingsSubsectionWrapper>
    </SettingsSectionWrapper>
  );
});

const Selector = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;
